import { useEffect, useState } from "react";
import Shell from "../components/Shell";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Plus, Trash2, ArrowUp, ArrowDown } from "lucide-react";

export default function AdminSettings() {
  const [steps, setSteps] = useState([]);

  const load = async () => {
    try { const { data } = await api.get("/admin/onboarding-template"); setSteps(data.steps || []); }
    catch { toast.error("Admin access required"); }
  };
  useEffect(() => { load(); }, []);

  const addStep = () => setSteps([...steps, { order: steps.length + 1, title: "", description: "" }]);
  const removeStep = (i) => setSteps(steps.filter((_, idx) => idx !== i).map((s, idx) => ({ ...s, order: idx + 1 })));
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= steps.length) return;
    const copy = [...steps];
    [copy[i], copy[j]] = [copy[j], copy[i]];
    setSteps(copy.map((s, idx) => ({ ...s, order: idx + 1 })));
  };
  const update = (i, field, val) => {
    const copy = [...steps]; copy[i] = { ...copy[i], [field]: val }; setSteps(copy);
  };

  const save = async () => {
    if (steps.some((s) => !s.title.trim())) return toast.error("All steps need a title");
    try {
      await api.put("/admin/onboarding-template", { steps });
      toast.success("Template saved. Applies to future agent signups.");
    } catch { toast.error("Failed to save"); }
  };

  return (
    <Shell>
      <div className="p-4 sm:p-8 max-w-4xl" data-testid="admin-settings-page">
        <div className="label-xs text-amber">&gt; ADMIN / ONBOARDING_TEMPLATE</div>
        <h1 className="font-display text-3xl sm:text-5xl leading-none mt-2">Onboarding.</h1>
        <p className="mt-2 text-fg-muted font-mono text-sm">Customize the onboarding path for new agents. Existing agents keep their current steps.</p>

        <div className="mt-8 space-y-3">
          {steps.map((s, i) => (
            <div key={i} className="border border-term bg-raised p-4" data-testid={`template-step-${i}`}>
              <div className="flex items-center gap-3 mb-3">
                <div className="label-xs text-amber w-16">STEP {String(s.order).padStart(2, "0")}</div>
                <div className="flex gap-1 ml-auto">
                  <button onClick={() => move(i, -1)} disabled={i === 0} className="p-1 border border-term text-fg-muted disabled:opacity-30 hover:border-fg-muted"><ArrowUp size={12} /></button>
                  <button onClick={() => move(i, 1)} disabled={i === steps.length - 1} className="p-1 border border-term text-fg-muted disabled:opacity-30 hover:border-fg-muted"><ArrowDown size={12} /></button>
                  <button onClick={() => removeStep(i)} className="p-1 border border-term text-fg-muted hover:border-live hover:text-live"><Trash2 size={12} /></button>
                </div>
              </div>
              <input placeholder="Step title" className="input-term mb-2" value={s.title} onChange={(e) => update(i, "title", e.target.value)} />
              <textarea placeholder="Description" rows={2} className="input-term text-sm" value={s.description} onChange={(e) => update(i, "description", e.target.value)} />
            </div>
          ))}
        </div>

        <div className="mt-6 flex gap-3">
          <button onClick={addStep} className="btn-ghost" data-testid="add-step-btn"><Plus size={12} /> Add Step</button>
          <button onClick={save} className="btn-primary ml-auto" data-testid="save-template-btn">Save Template &gt;</button>
        </div>
      </div>
    </Shell>
  );
}
